
interface ServicesSectionProps {
  onContactClick: () => void;
}

export default function ServicesSection({ onContactClick }: ServicesSectionProps) {
  const services = [
    {
      title: "Residential Carpet Cleaning",
      description: "Carpet flooring is the perfect material to create a cozy atmosphere, but it accumulates dust and dirt quickly. Steam cleaning is the most effective carpet cleaning method that helps keeping your home clean and sanitary.",
      price: "From $89.00",
      image: "https://www.canadacleanhome.com/wp-content/uploads/2021/03/Residential-Carpet-Cleaning.jpg",
      link: "#"
    },
    {
      title: "Furniture & Upholstery Cleaning",
      description: "To preserve your furniture's value, function and safety, upholstery & leather furniture needs professional care. We recommend steam cleaning your furniture once a year.",
      price: "From $49.00",
      image: "https://www.canadacleanhome.com/wp-content/uploads/2021/03/Furniture-Upholstery-Cleaning.jpg",
      link: "#"
    },
    {
      title: "Commercial Carpet and Furniture Cleaning",
      description: "Every business wants to meet their customers in a clean, welcoming and safe environment, but high traffic areas get dusty and dirty very quickly.",
      price: "Custom Pricing",
      image: "https://www.canadacleanhome.com/wp-content/uploads/2021/04/Commercial-Carpet-and-Furniture.jpg",
      link: "#"
    },
    {
      title: "Carpet Cleaning in Apartments and Condos",
      description: "We bring our Portable Machine right to your condo. It provides the same deep steam cleaning as our truck mounted equipment!",
      price: "From $99.00",
      image: "https://www.canadacleanhome.com/wp-content/uploads/2021/03/Carpet-Cleaning-in-Apartments-and-Condos.jpg",
      link: "#"
    },
    {
      title: "Vehicle Interior Steam Cleaning",
      description: "Vehicles, RVs or working trucks are places where we spend a lot of time daily. It's important to keep it clean and safe. Deep steam cleaning returns that new vehicle look and smell.",
      price: "Custom Pricing",
      image: "https://www.canadacleanhome.com/wp-content/uploads/2021/03/Vehicle-Interior-Cleaning.jpg",
      link: "#"
    },
    {
      title: "Odor Removal",
      description: "Top-notch odor removal services to rejuvenate your vehicles, homes, and commercial spaces. Experience Fresh & Clean Air with eco-friendly products and cutting-edge techniques.",
      price: "Custom Pricing",
      image: "https://www.canadacleanhome.com/wp-content/uploads/2023/11/odor-removal.jpg",
      link: "#"
    }
  ];

  const bookingUrl = 'https://www.housecallpro.com/book/Blue-Team-Carpet--Dryer-Vent-Cleaning?company=80c78a4651b14af9b1112d122f1ff5d3';

  return (
    <section className="py-20 bg-white" id="services">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <header className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Services</h2>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <article key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="aspect-video overflow-hidden">
                <img 
                  src={service.image} 
                  alt={`${service.title} - Professional cleaning services in Escondido`}
                  title={`${service.title} by Blue Team`}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600 mb-4 text-sm leading-relaxed">{service.description}</p>
                
                <div className="mb-4">
                  <div className="text-2xl font-bold text-teal-600">{service.price}</div>
                  <div className="text-sm text-gray-500">Fees & Taxes are extra</div>
                </div>

                <div className="flex space-x-2">
                  <a 
                    href={service.link} 
                    className="flex-1 bg-gray-100 text-gray-700 py-2 px-4 rounded-lg text-center text-sm font-medium hover:bg-gray-200 transition-colors cursor-pointer"
                    rel="nofollow"
                  >
                    Learn More
                  </a>
                  <a
                    href={bookingUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-1 bg-teal-600 text-white py-2 px-4 rounded-lg text-center text-sm font-medium hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap inline-block"
                  >
                    Book Now
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* CTA Section */}
        <div className="mt-20 bg-teal-600 rounded-2xl p-8 text-center text-white">
          <h3 className="text-3xl font-bold mb-4">Same Day Service! Contact for Availability & Estimate!</h3>
          <a
            href={bookingUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white text-teal-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer inline-block mt-4"
          >
            Book Your Service Now
          </a>
        </div>
      </div>
    </section>
  );
}
